// extracted by mini-css-extract-plugin
export default {"label-text":"events-editing-client-js-editing-timeline-___StateIndicator-module__label-text___2RX98"};